
define('ldsh!modules/templates/templates/modal_preview', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-overlay-container ed-modal-preview-temp">\n  <div class="ed-modal-header ed-opt-toolbar">\n    <h3 class="ed-modal-title">' +
__e( name ) +
'</h3>\n    <button data-dismiss="modal" class="close js-close" type="button" aria-hidden="true">\n      <i class="ri-close-line"></i>\n    </button>\n  </div>\n  <div class="ed-modal-content ed-opt-content">\n    <img src="' +
((__t = ( previewUrl )) == null ? '' : __t) +
'" alt="' +
__e( name ) +
'" title="' +
__e( name ) +
'" />\n  </div>\n  <div class="ed-modal-footer ed-opt-btnbar">\n    <button\n      type="button"\n      class="btn--ghost e100 js-close"\n      data-i18n="common.cancelButton"\n    ></button>\n    <button\n      type="button"\n      class="ed-btn ed-btn-primary-action js-select"\n      data-i18n="common.selectButton"\n    ></button>\n  </div>\n</div>\n';

}
return __p
};});

